import script from "./LessonVideoTab.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonVideoTab.vue?vue&type=script&setup=true&lang=js"

import "./LessonVideoTab.vue?vue&type=style&index=0&id=017d7ef6&lang=css"

const __exports__ = script;

export default __exports__